import moment from 'moment';
import {
  differenceInCalendarDays,
  format,
  formatDistance,
  formatDistanceStrict
} from 'date-fns';
import { ru } from 'date-fns/locale';

export function formatTimeDate(date) {
  return moment(date).format('HH:mm DD.MM.YYYY');
}

export function formatDateTime(date) {
  return moment(date).format('DD.MM.YYYY HH:mm');
}

export function formatRelativeDate(date) {
  const parsed = new Date(date);
  const now = new Date();

  if (differenceInCalendarDays(now, parsed) > 2) {
    return format(parsed, 'd MMM yyyy', { locale: ru });
  }

  return formatDistance(parsed, now, { addSuffix: true, locale: ru });
}

// "2 часа назад", "3 дня назад": one unit, never switches to a calendar date
export function formatTimeAgo(date) {
  return formatDistanceStrict(new Date(date), new Date(), {
    addSuffix: true,
    locale: ru
  });
}
